import React from "react";
import Tooltip from "@material-ui/core/Tooltip";
import Chip from "@material-ui/core/Chip";

import AccessTimeIcon from '@material-ui/icons/AccessTime';
import BlockIcon from '@material-ui/icons/Block';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import AdjustOutlinedIcon from '@material-ui/icons/AdjustOutlined';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import HelpOutlineIcon from '@material-ui/icons/HelpOutline';

import "./style.css";

const lookup = [

  {
    value: -1,
    text: "Отклонена"
  },
  {
    value: 0,
    text: "Новая"
  },
  {
    value: 1,
    text: "В работе"
  },
  {
    value: 2,
    text: "Подтверждена"
  },
  {
    value: 3,
    text: "Архив"
  }
];

function requestStateExcelCell(options, column, gridCell) {
  if (gridCell.value === 0) {
    options.value = "Новая";
  } else if (gridCell.value === 1) {
    options.value = "В работе";
  } else if (gridCell.value === 2) {
    options.value = "Подтверждена";
  } else if (gridCell.value === -1) {
    options.value = "Отклонена";
  } else if (gridCell.value === 3) {
    options.value = "Архив";
  }
}

function requestStateCell(config) {
  config.cellRender = RequestStateCell;
  config.dataType = "number";
  config.alignment = "center";
  config.lookup = {
    dataSource: lookup,
    valueExpr: "value",
    displayExpr: "text"
  }
}

const groupSateTextColor = {
  '-1': "#F15454",
  '0': "#304967",
  '1': "#007FBD",
  '2': "#85C446",
  '3': "#CACCD1"
};

const RequestStateCell = (cellData) => {
  switch (cellData.value) {
    case 0:
      return (
        <div>
          <Tooltip title="Новая">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<AdjustOutlinedIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 1:
      return (
        <div>
          <Tooltip title="В работе">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<AccessTimeIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 2:
      return (
        <div>
          <Tooltip title="Подтверждена">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<CheckCircleOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case 3:
      return (
        <div>
          <Tooltip title="Архив">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<CheckBoxOutlineBlankIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    case -1:
      return (
        <div>
          <Tooltip title="Отклонена">
            <Chip color="primary"
                  style={{ "background": groupSateTextColor[cellData.value]}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<BlockIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      );
    default:
      return (
        <div>
          <Tooltip title="Статус не указан">
            <Chip color="primary"
                  style={{ "background": "#000000"}}
                  size="small"
                  classes={{
                    label: 'labelChip',
                    icon: 'iconChip'
                  }}
                  icon={<HelpOutlineIcon fontSize={"small"}/>}/>
          </Tooltip>
        </div>
      )
  }
};


export {requestStateCell, requestStateExcelCell, RequestStateCell}
